module.exports = __webpack_public_path__ + "static/media/main-banner.da55b9cb.jpg";